import React, { useState } from 'react';
import { Button, Col, Form, Input, Modal, Row, Space, notification } from 'antd';
import { adminCreateUser } from '../../api/admin';

type CreateUserModalProps = {
  open: boolean;
  onCancel: () => void;
  onSuccess?: () => void;
};

const CreateUserModal: React.FC<CreateUserModalProps> = ({ open, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleCreate = async (values: any) => {
    try {
      setLoading(true);
      await adminCreateUser(values);
      notification.success({
        message: 'User created',
        description: 'The user was created successfully.',
        placement: 'topRight',
      });
      form.resetFields();
      onSuccess?.();
      onCancel();
    } catch (e: any) {
      notification.error({
        message: 'Create user failed',
        description: e?.message || String(e),
        placement: 'topRight',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Create User"
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleCreate}>
        <Row gutter={16}>
          <Col span={12}><Form.Item name="email" label="Email" rules={[{ required: true }]}><Input /></Form.Item></Col>
          <Col span={12}><Form.Item name="password" label="Password" rules={[{ required: true, min: 8 }]}><Input.Password /></Form.Item></Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}><Form.Item name="firstName" label="First Name"><Input /></Form.Item></Col>
          <Col span={12}><Form.Item name="lastName" label="Last Name"><Input /></Form.Item></Col>
        </Row>
        <Form.Item>
          <Space>
            <Button onClick={onCancel} disabled={loading}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>Create</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateUserModal;
